document.addEventListener('DOMContentLoaded', function () {
  setupSeamlessBgVideoLoop();
  setupEmailValidation();

  if (window.NovaeLenis && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var lenis = window.NovaeLenis.init();
    setupHeroParallax(lenis);
  }

  var section = document.querySelector('.novae-coming-soon');
  if (!section || !window.NovaeMotion) return;

  var elements = section.querySelectorAll('[data-animate]');
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  window.NovaeMotion.animate(
    elements,
    { opacity: [0, 1], transform: ['translateY(24px)', 'translateY(0)'] },
    { duration: 0.8, delay: window.NovaeMotion.stagger(0.12), ease: 'easeOut' }
  );

  var formulaImage = document.querySelector('.novae-formula__image');
  if (formulaImage && window.NovaeMotion.inView) {
    window.NovaeMotion.inView(
      formulaImage,
      function () {
        window.NovaeMotion.animate(formulaImage, { opacity: [0, 1] }, { duration: 1, ease: 'easeOut' });
      },
      { amount: 0.4 }
    );
  }

  var noteList = document.querySelector('.novae-formula__note-list');
  var noteItems = document.querySelectorAll('.novae-formula__note-item');
  if (noteList && noteItems.length && window.NovaeMotion.inView) {
    window.NovaeMotion.inView(
      noteList,
      function () {
        window.NovaeMotion.animate(
          noteItems,
          { opacity: [0, 1], transform: ['translateY(24px)', 'translateY(0)'] },
          { duration: 0.7, delay: window.NovaeMotion.stagger(0.12), ease: 'easeOut' }
        );
      },
      { amount: 0.3 }
    );
  }
});

// Client-side email validation for the coming-soon signup form, layered on
// top of (not replacing) Shopify's own server-side validation - the native
// `type="email"` check only catches gross malformations (no "@" at all) in
// most browsers, so this adds a TLD-aware regex (requires a "." followed by
// 2+ letters) and surfaces the failure as an inline message under the entry
// bar instead of the browser's native validation bubble, which the rest of
// the form's styling doesn't match. `form.noValidate` is set so the native
// bubble never fires alongside this custom message.
//
// The form as a whole is also submitted via fetch() rather than a normal
// browser navigation. `{% form 'customer' %}` is a plain full-page POST, so
// letting the browser submit it directly means every submission - valid or
// invalid - triggers a full page reload (a visible flicker), and any
// rejection Shopify itself catches (vs. our regex) renders as its bare,
// unstyled `form.errors` text after that reload. Intercepting the submit
// and swapping the response's `[data-novae-form-body]` fragment into the
// live DOM gets the same server-validated outcome (success message or
// error list) with no navigation at all.
var NOVAE_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

function setupEmailValidation() {
  var form = document.getElementById('NovaeComingSoonForm');
  if (!form || form.dataset.novaeBound) return;
  form.dataset.novaeBound = 'true';
  form.noValidate = true;

  function getRefs() {
    return {
      input: form.querySelector('#NovaeComingSoonEmail'),
      field: form.querySelector('.novae-coming-soon__field'),
      errorEl: form.querySelector('#NovaeComingSoonEmailError')
    };
  }

  function showError(refs, message) {
    if (!refs.field || !refs.errorEl) return;
    refs.errorEl.textContent = message;
    refs.errorEl.hidden = false;
    refs.field.classList.add('novae-coming-soon__field--invalid');
    refs.input.setAttribute('aria-invalid', 'true');
  }

  function clearError(refs) {
    if (!refs.field || !refs.errorEl) return;
    refs.errorEl.textContent = '';
    refs.errorEl.hidden = true;
    refs.field.classList.remove('novae-coming-soon__field--invalid');
    refs.input.removeAttribute('aria-invalid');
  }

  form.addEventListener('input', function (event) {
    if (event.target.id !== 'NovaeComingSoonEmail') return;
    clearError(getRefs());
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();

    var refs = getRefs();
    if (!refs.input) return;
    var value = refs.input.value.trim();

    if (!value || !NOVAE_EMAIL_PATTERN.test(value)) {
      // Message text comes from the locale files (novae.home.email_invalid) via
      // a data attribute, so it follows the page language.
      showError(refs, (refs.errorEl && refs.errorEl.dataset.invalidMessage) ||'Please enter a valid email address.');
      refs.input.focus();
      return;
    }

    clearError(refs);
    submitFormViaFetch(form);
  });
}

function submitFormViaFetch(form) {
  var submitButton = form.querySelector('.novae-glass-button');
  if (submitButton) submitButton.disabled = true;

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var freshBody = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-novae-form-body]');
      var currentBody = form.querySelector('[data-novae-form-body]');
      if (freshBody && currentBody) {
        currentBody.replaceWith(freshBody);
        if (window.NovaeGlassButton) window.NovaeGlassButton.init(freshBody);
      } else {
        form.submit();
      }
    })
    .catch(function () {
      // Network failure - fall back to a real submission so the entry isn't lost.
      form.submit();
    })
    .finally(function () {
      if (submitButton) submitButton.disabled = false;
    });
}

// The submit button's arrow-morph interaction used to be wired up here
// as setupSubmitArrowMorph(). It's now part of the reusable
// .novae-glass-button component instead - see
// assets/novae-glass-button.js, which self-initializes on
// DOMContentLoaded for every .novae-glass-button on the page, so nothing
// needs to be called from here anymore.

// Drifts the hero's text/logo/form up at 10% of the white panel's own scroll
// speed (the background video is a sibling and is left untouched, so it
// stays put) - slow enough that the panel's leading edge always overtakes
// and covers this content before it would otherwise scroll off the top.
function setupHeroParallax(lenis) {
  var content = document.querySelector('.novae-coming-soon__content');
  if (!content || !lenis) return;

  var PARALLAX_RATE = 0.1;

  lenis.on('scroll', function (instance) {
    content.style.transform = 'translateY(' + -(instance.scroll * PARALLAX_RATE) + 'px)';
  });
}

// Crossfades between two copies of the same clip just before each one's
// natural end, so the native `loop` decoder-restart stutter/black-flash
// (which happens even when the seam frames match perfectly) is masked by
// the other copy already playing underneath it.
function setupSeamlessBgVideoLoop() {
  var videos = document.querySelectorAll('[data-bgvideo]');
  if (videos.length < 2) return;

  var CROSSFADE_MS = 600; // must match the CSS opacity transition duration
  var CROSSFADE_LEAD = 0.9; // seconds before the clip's end to start the swap

  var active = videos[0];
  var standby = videos[1];
  var swapping = false;

  try {
    standby.pause();
    standby.currentTime = 0;
  } catch (e) {}

  function onTimeUpdate(event) {
    var video = event.target;
    if (video !== active || swapping || !video.duration) return;
    if (video.currentTime < video.duration - CROSSFADE_LEAD) return;

    swapping = true;
    try {
      standby.currentTime = 0;
    } catch (e) {}
    standby.play().catch(function () {});

    video.classList.remove('is-active');
    standby.classList.add('is-active');

    var outgoing = active;
    active = standby;
    standby = outgoing;

    setTimeout(function () {
      outgoing.pause();
      try {
        outgoing.currentTime = 0;
      } catch (e) {}
      swapping = false;
    }, CROSSFADE_MS);
  }

  videos.forEach(function (video) {
    video.addEventListener('timeupdate', onTimeUpdate);
  });
}
